// extracted by mini-css-extract-plugin
module.exports = {"head":"OnboardingModal_head__gTYLm","localeSwitcher":"OnboardingModal_localeSwitcher__tw996"};